module.exports = __webpack_public_path__ + "static/media/img-map-eta.ff75ca22.png";